// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"78":"e79728da","226":"8b22ad45","250":"0d0a7548","304":"54f9deb1","338":"b1f6aff7","489":"d2a12cdc","544":"29583000","576":"e4ffe8d7","753":"5e336555","775":"09327436","823":"88aa24c4","990":"002c40c9"}[chunkId] + ".js";
};